var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.1667V10.6667H5.5V7.33335H11.3333V4.83335L15.5 9.00002L11.3333 13.1667ZM9.66667 0.666687C10.1087 0.666687 10.5326 0.842282 10.8452 1.15484C11.1577 1.4674 11.3333 1.89133 11.3333 2.33335V4.00002H9.66667V2.33335H2.16667V15.6667H9.66667V14H11.3333V15.6667C11.3333 16.1087 11.1577 16.5326 10.8452 16.8452C10.5326 17.1578 10.1087 17.3334 9.66667 17.3334H2.16667C1.72464 17.3334 1.30072 17.1578 0.988155 16.8452C0.675595 16.5326 0.5 16.1087 0.5 15.6667V2.33335C0.5 1.89133 0.675595 1.4674 0.988155 1.15484C1.30072 0.842282 1.72464 0.666687 2.16667 0.666687H9.66667Z",
    fill: "#273043"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fe3b049645f328d5fdf48bd16efeae8d.svg";
export { ForwardRef as ReactComponent };